import { Tracker } from './tracker.types';
import { PreviewModeTracker } from './preview-mode-tracker';
import { DefaultTracker } from './default-tracker';
import { storage } from './utility/storage';
import { console } from './utility/console';
import { PublicTrackerMethod, PublicTrackerMethodName, TrackerReturnType, TrackerSender } from './tracker-sender.types';

type PreviewToken = string | null;
let previewToken: PreviewToken;
try {
  const searchParams = new URLSearchParams(window.location.search);
  previewToken = searchParams.get('rpr_preview_token');
} catch (err) {}

export class Router implements TrackerSender {
  private tracker: Tracker;

  constructor() {
    this.tracker = previewToken === null ? new DefaultTracker() : new PreviewModeTracker(previewToken);
  }

  // send: TrackerSender['send'] = (funcName, ...args) => {
  public send<F extends PublicTrackerMethodName>(
    funcName: F,
    ...args: Parameters<PublicTrackerMethod[F]>
  ): TrackerReturnType {
    if (!storage.isAvailable) return;

    if (typeof this.tracker[funcName] !== 'function') {
      console.error(`"${funcName}" is not a valid function call`);
      return false;
    }
    // TODO: 将来的に型をもっとしっかり付けて as を使わなくて済むようにした方がよいが、現状では一旦 as で回避しておく
    // ちなみに typescript は現状 tupple でないと spread を使えない ref: https://github.com/microsoft/TypeScript/issues/47615
    return this.tracker[funcName](...(args as [string, any]));
  }
}
